import { secondaryCriteriaTemplate } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveSecondaryCriteriaTemplateRequestFailure(namespace, type) {
      const req = getState().find(
        (req) => req.type === type && req.namespace === namespace,
      );

      return req ? req.request.isFailure : false;
    },
    isRetrieveSecondaryCriteriaTemplateRequestPending(namespace, type) {
      const req = getState().find(
        (req) => req.type === type && req.namespace === namespace,
      );

      return req ? req.request.isPending : false;
    },
    isRetrieveSecondaryCriteriaTemplateRequestSuccess(namespace, type) {
      const req = getState().find(
        (req) => req.type === type && req.namespace === namespace,
      );

      return req ? req.request.isSuccessful : false;
    },
    getSecondaryCriteriaTemplate(namespace, type) {
      const req = getState().find(
        (req) => req.type === type && req.namespace === namespace,
      );

      return req ? req.template : secondaryCriteriaTemplate;
    },
  };
}

export { createSelector };
